import { render, staticRenderFns } from "./ticketSure.vue?vue&type=template&id=89dbd87a&scoped=true&"
import script from "./ticketSure.vue?vue&type=script&lang=js&"
export * from "./ticketSure.vue?vue&type=script&lang=js&"
import style0 from "./ticketSure.vue?vue&type=style&index=0&id=89dbd87a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dbd87a",
  null
  
)

export default component.exports